import { render } from "./Proximidade.vue?vue&type=template&id=096ce1fe&scoped=true"
import script from "./Proximidade.vue?vue&type=script&lang=js"
export * from "./Proximidade.vue?vue&type=script&lang=js"

import "./Proximidade.vue?vue&type=style&index=0&id=096ce1fe&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096ce1fe"]])

export default __exports__